import tick_pro from "../../../assets/images/tick_pro.svg";
import { IoCloseOutline } from "react-icons/io5";
import { Divider } from "@mui/material";

export default function ChoseBigm() {
  return (
    <div className="w-full flex flex-col gap-3">
      <div className="w-full rounded-[8px] bg-[#1C9BDB] h-[72px] px-[8px] py-[6px] flex gap-4 items-center">
        <div className="w-[54px] h-[54px] rounded-full bg-[#E1F7FF] flex items-center justify-center ">
          <p>01</p>
        </div>
        <div>
          <p className="w-[200px] text-[20px] font-semibold text-white lg:text-[28px] lg:font-semibold lg:whitespace-nowrap">
            Học viện giáo dục Bigmax Academy
          </p>
        </div>
      </div>
      <div className="w-full bg-[#E4F7FF] h-[97px] lg:h-[52px] lg:rounded-[30px] rounded-[16px] px-[16px] py-[8px] lg:px-[20px]">
        <div className="flex items-center justify-around lg:flex lg:items-center lg:justify-between gap-2">
          <div>
            <p className="w-[100px] lg:text-[24px] font-semibold text-[#1C9BDB] lg:whitespace-nowrap">
              Ưu điểm
            </p>
          </div>
          <div className="flex items-center justify-between w-[130px] lg:w-[200px] gap-5">
            <p className="w-[89px] lg:whitespace-nowrap relative lg:right-[350px] lg:text-[24px] font-semibold lg:text-[#1C9BDB] ">
              Bigmax Academy
            </p>
            <p className="w-[58px] lg:whitespace-nowrap relative lg:right-[230px] lg:text-[24px] font-semibold lg:text-[#1C9BDB]   ">
              Trung tâm khác
            </p>
          </div>
        </div>
      </div>
      <div>
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Hệ thống giáo dục học tập thông minh
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px] lg:font-normal">
              100% do người Việt Nam thực hiện, mang nhiều tính năng quản lý dạy
              học & tự kèm con học kết nối giáo viên - phụ huynh - học sinh
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div className="bg-[#FAFAFA]">
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Mô hình dạy & học Blended Learning
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Kết hợp hình thức Online & Offline với sự điều phối chặt chẽ của
              giáo viên - giúp học sinh tiếp thu kiến thức nhanh chóng, hiệu quả
              & cam kết đầu ra theo yêu cầu của phụ huynh học sinh.
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Divider />
      </div>
      <div>
        <div className="flex items-center justify-around gap-2 lg:flex lg:justify-between lg:px-[20px] px-11">
          <div className="lg:flex-col lg:gap-5 lg:flex lg:text-start w-full">
            <p className="w-[100px] lg:w-full lg:text-[16px] lg:text-[#333333] font-semibold">
              Kho tài nguyên phong phú{" "}
            </p>
            <p className="hidden md:block lg:block w-full lg:w-[500px]">
              Hơn 50.000 bài tập đề thi từ cơ bản đến nâng cao được thiết kế tối
              ưu giúp tăng hiệu quả dạy và học
            </p>
          </div>
          <div className="flex justify-between items-center w-[160px] lg:w-[300px] lg:relative lg:right-[200px]">
            <div className="w-[32px] h-[32px] bg-[#3DB72D] flex items-center justify-center rounded-full">
              <img src={tick_pro} alt="" />
            </div>
            <div className="w-[32px] h-[32px] bg-[#C7C7C7] flex items-center justify-center rounded-full">
              <IoCloseOutline />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
